// extracted by mini-css-extract-plugin
export default {"item":"LoadingMenu_item__ZUcVy"};